import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { formatError, ValidationError } from "@/components/ui/validation-error";
import { createAttributeComponent } from "@coltorapps/builder-react";
import CodeToggle from "@ui/code-toggle";
import CodeEditButton, {
  DEFAULT_TRIGGER_TEXT,
} from "@ui/button/code-edit-button";
import { ExpressionDefault, ExpressionType } from "@/const/expression";
import {
  normalizeTargetUrlAttribute,
  targetUrlAttribute,
} from "./definition";

export const TargetUrlAttribute = createAttributeComponent(
  targetUrlAttribute,
  function TargetUrlAttribute(props) {
    const value = normalizeTargetUrlAttribute(props.attribute.value);
    const fieldError = formatError(props.attribute.value, props.attribute.error)
      ?._errors?.[0];

    return (
      <div className="flex flex-col gap-2">
        <div className="flex flex-row items-center justify-between gap-3">
          <Label htmlFor={props.attribute.name}>Target URL</Label>
          <CodeToggle
            value={value.mode === "expression" ? "code" : "manual"}
            onChange={(nextMode) => {
              props.setValue({
                ...value,
                mode: nextMode === "code" ? "expression" : "fixed",
              });
            }}
          />
        </div>
        {value.mode === "expression" ? (
          <CodeEditButton
            variant="reference"
            title="Target URL Expression"
            value={
              value.expression ||
              ExpressionDefault[ExpressionType.ActionButtonUrl]
            }
            trigger={value.expression?.trim() || DEFAULT_TRIGGER_TEXT}
            onSave={(expression) => {
              props.setValue({
                ...value,
                mode: "expression",
                expression,
              });
            }}
          />
        ) : (
          <Input
            id={props.attribute.name}
            value={value.value || ""}
            onChange={(e) => {
              props.setValue({
                ...value,
                mode: "fixed",
                value: e.target.value,
              });
            }}
            className={fieldError ? "border-red-500" : ""}
            placeholder="https://"
          />
        )}
        <ValidationError>{fieldError}</ValidationError>
      </div>
    );
  },
);
